import React from 'react';
import { useNavigate, useParams, Navigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Lock, Construction } from 'lucide-react';

// Wave 5A P3 — this is a plain empty/placeholder state only.
// No session load, no flow logic, and no backend calls run here (P1-P3 scope).
const CHOICE_CONTENT = {
  'historical-stocktake': {
    title: 'Add a completed historical stocktake',
    description: 'Import a completed legacy stocktake as a locked, read-only AbbeyZone session.',
    icon: Lock,
    color: 'bg-violet-600',
  },
};

export default function ImportStocktakeComingSoonPage() {
  const navigate = useNavigate();
  const { choice } = useParams();
  const content = CHOICE_CONTENT[choice];

  if (!content) {
    return <Navigate to="/stocktaking/import" replace />;
  }

  const Icon = content.icon;

  return (
    <div className="space-y-6" data-testid="import-stocktake-coming-soon-page">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate('/stocktaking/import')}
          data-testid="back-to-import-landing"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">{content.title}</h1>
        </div>
      </div>

      <Card className="border-2 border-dashed">
        <CardHeader className="items-center text-center">
          <div className={`${content.color} w-14 h-14 rounded-lg flex items-center justify-center mb-3`}>
            <Icon className="h-7 w-7 text-white" />
          </div>
          <CardTitle data-testid="coming-soon-title">This step isn't available yet</CardTitle>
          <CardDescription data-testid="coming-soon-description">
            {content.description} This part of the import journey is still being built.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3 pb-6">
          <Construction className="h-5 w-5 text-slate-400" />
          <Button variant="outline" onClick={() => navigate('/stocktaking/import')} data-testid="coming-soon-back-button">
            Back to import choices
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
